export enum CustomerTypeEnum {
  Unknown = 0,
  Other = 1,
  Residential = 10,
  Commercial = 11,
  Government = 12,
  NonProfit = 13,
}

export enum CustomerRoleEnum {
  Unknown = 0,
  Other = 1,
  Admin = 10,
  Basic = 11,
}
